export default __webpack_public_path__ + "static/media/emptyWishlist.5544faee.svg";